import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { fadeUp, stagger, viewport } from "../lib/motion";
import Breadcrumb from "../components/site/Breadcrumb";
import CTABand from "../components/site/CTABand";

export default function Industries() {
  const [industries, setIndustries] = useState([]);
  useEffect(() => {
    api.industries().then(setIndustries);
  }, []);

  return (
    <div>
      <section className="bg-[#F8FAF8] border-b border-[#E2E8E4] pt-12 pb-16">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <Breadcrumb items={[{ label: "Industries" }]} />
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#1D6B2A] mt-6 mb-3">
            Industries we serve
          </p>
          <h1 className="font-head text-4xl md:text-6xl font-medium tracking-tighter text-[#0A1C0E] max-w-3xl">
            Packaging tailored to how you serve
          </h1>
          <p className="text-lg text-[#3A4D3E] mt-4 max-w-2xl">
            From single outlets to multi-city chains, we supply the right packaging for every
            food business across India.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {industries.map((ind, i) => (
              <motion.div
                key={ind.name}
                variants={fadeUp}
                custom={i}
                className="bg-white border border-[#E2E8E4] rounded-2xl p-8 hover:-translate-y-1 hover:shadow-xl transition-all duration-500"
              >
                <span className="font-editorial text-4xl text-[#1D6B2A]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-head text-2xl font-semibold text-[#0A1C0E] mt-3">{ind.name}</h3>
                <p className="text-[#3A4D3E] mt-3 leading-relaxed">{ind.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
